module.exports = __webpack_public_path__ + "static/media/Inter-ExtraLight.c36ac5a2.ttf";